// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { menuPanelRowResetStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { buttonResetProps } from "@store/Themes/common/props/button";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const panelMenu: Styleguide["panelMenu"] = {
    defaultProps: {
        cssOverrides: {
            children: css`
                padding: 0 ${pxToRem(20)};
                background-color: ${getColor("common.background")};
            `,
            menu: css`
                flex: 1 1 auto;
            `,
        },
        closeButtonPanelRowProps: {
            css: css`
                justify-content: flex-start;
            `,
        },
        headerColor: "common.background",
        bodyColor: "common.background",
        childTypographyProps: {
            color: "primary",
            css: css`
                font-weight: ${({ theme }) => theme.design.typography.weight.base};
            `,
        },
        panelRowProps: {
            color: "common.background",
            moreIconProps: {
                color: "primary",
                css: css`
                    color: ${getColor("primary")};
                    svg {
                        stroke: ${getColor("primary")};
                    }
                `,
            },
            css: css`
                width: 100%;
                padding: ${pxToRem(20)} 0;
                padding-left: ${pxToRem(15)};
                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

                *:not(svg):not(path) {
                    color: ${getColor("text.main")};
                }

                &:hover * {
                    color: ${getColor("primary")};
                }

                &:focus,
                &:active {
                    background-color: ${getColor("common.background")} !important;
                    outline-offset: ${pxToRem(-2)};
                }
            `,
            // Theme doesn't work here. Needs to be investigated
            isCurrentCss: css`
                background-color: #f4f4f4; /* common.background color */

                [class*="TypographyStyle"] {
                    font-weight: 700; /* theme.design.typography.weight.bold */
                }
            `,
        },
        closeButtonProps: menuPanelProps.closeButton,
        closeIconProps: {
            color: "primary",
            css: css`
                svg {
                    stroke: ${getColor("primary")};
                }
            `,
        },
        parentPanelRowProps: {
            css: css`
                border-top: 1px solid ${getColor("common.border")};
                border-bottom: 1px solid ${getColor("common.border")};
            `,
        },
        backButtonProps: {
            css: css`
                width: 100%;
                display: flex;
                align-items: center;
                padding: 0 !important;
            `,
        },
        parentLinkProps: {
            css: css`
                ${menuPanelRowStyles({
                    iconPosition: "right",
                    color: "menu.mainNavigation.accent",
                    hoverColor: "menu.mainNavigation.accentHover",
                })}

                flex: 0 0 0%;
                white-space: nowrap;
                padding-left: 0;
            `,
        },
        backIconProps: {
            css: css`
                svg {
                    stroke: ${getColor("primary")};
                }
            `,
        },
        parentTypographyProps: {
            size: 17,
            weight: "bold",
            color: "text.main",
            css: css`
                text-transform: capitalize;
            `,
        },
    },
};

export default panelMenu;
